import { Box } from '@origin-digital/style-guide';
import * as React from 'react';

import { QualifyingFieldProps } from './QualifyingField.types';
import AlertBanner from '../../../AlertBanner';

// @ts-ignore
import stepOne from '../../../../apps/SolarContact/components/RequestQuote/meta/stepOne.json';

const QualifyingField: React.StatelessComponent<QualifyingFieldProps> = ({
  ...props
}: QualifyingFieldProps): JSX.Element => {
  const { name, isValid, children, errors, recordDisqualification, marginTopOffset, disqualificationMessage } = props;
  const error = errors[name] || false;

  return (
    <React.Fragment>
      <Box>{children}</Box>
      <Box marginTop={marginTopOffset}>
        <AlertBanner
          show={error && !isValid}
          heading={stepOne.form.content.disqualification.heading}
          name={name}
          hasError={errors[name]}
          message={disqualificationMessage[name]}
          recordDisqualification={recordDisqualification}
        />
      </Box>
    </React.Fragment>
  );
};

export { QualifyingField as default };
